import type { ContentHref } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { selectProposalMetaInfo } from '@newStore/documentUI/transformProposal/proposalSelectors';
import { useSelector } from 'react-redux';
import ProposalIndicator from './ProposalIndicator';

const ProposalIndicatorForDoc: React.FC<{
  href: ContentHref;
  parentHref: ContentHref | null;
}> = ({ href, parentHref }) => {
  const proposalMetaInfo = useSelector((state: RootState) => selectProposalMetaInfo(state, href));

  if (!proposalMetaInfo) {
    return null;
  }

  return (
    <ProposalIndicator href={href} parentHref={parentHref} proposalMetaInfo={proposalMetaInfo} />
  );
};

export default ProposalIndicatorForDoc;
